import './FormikDatePickerComponent.scss'
import React, {useCallback} from 'react';
import _ from "lodash";
import DatePickerComponent from "../date-picker/DatePickerComponent";
import {FieldProps} from "formik";
import {Moment} from "moment";

interface FormikDatePickerComponentProps {
    fullWidth?: boolean;
    id?: string;
    variant?: "filled" | "standard" | "outlined" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    size?: "small" | "medium" | undefined;
    formikField: FieldProps;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    format?: string;
    minDate?: Moment;
    maxDate?: Moment;
    onUpdate?: Function;
    label?: string;
    mask?: string;
}

const FormikDatePickerComponent = (props: FormikDatePickerComponentProps) => {

        const {
            label,
            id,
            formikField,
            required,
            readOnly,
            disabled,
            minDate,
            variant,
            color,
            maxDate,
            onUpdate,
            mask,
        } = props;

        const size = props.size || 'medium';
        const fullWidth = props.fullWidth || true;
        const {field, form} = formikField;
        const {name, value} = field;
        const {setFieldTouched, touched, errors, setFieldValue} = form;
        const hasError = _.get(touched, name) && !!(_.get(errors, name));

        const dateChangeHandler = useCallback((value: Date | null) => {
            setFieldValue(name, value);
            setFieldTouched(name);
            if (onUpdate) {
                onUpdate(value)
            }
        }, [setFieldValue, setFieldTouched, name, onUpdate]);

        return (
            <div>
                <DatePickerComponent
                    name={name}
                    id={id}
                    value={value}
                    size={size}
                    variant={variant}
                    color={color}
                    mask={mask}
                    label={label}
                    minDate={minDate}
                    maxDate={maxDate}
                    readOnly={readOnly}
                    disabled={disabled}
                    required={required}
                    fullWidth={fullWidth}
                    onDateChange={dateChangeHandler}
                    hasError={hasError}
                    errorMessage={hasError && _.get(errors, name)}
                />
            </div>
        )
    }

;

export default FormikDatePickerComponent;
